<template>
    <div id="home">
        <div v-if="app.template.type === '92fanli'">
            <NTfanliHome
                    :style-name="app.template.style"
                    :banner-data="bannerData"
                    :headline-data="headlineData"
                    :advert-a-data="advertAData"
                    :advert-b-data="advertBData"
                    :shop-data="shopData"
                    :brand-data="brandData"
                    :nine-data="nineData"
                    :tlj-data="tljData"
                    :goods-data="goodsData"
                    v-on:loadMore="fetchTopGoodsList"
                    v-on:mainScrollToTop="setMainScrollToTop"
                    v-on:wrapScrollToTop="setWrapScrollToTop"
                    ref="home"
            />
        </div>
        <div v-else-if="app.template.type === 'damai'">
            <DamaiHome
                    :style-name="app.template.style"
                    :banner-data="bannerData"
                    :headline-data="headlineData"
                    :advert-a-data="advertAData"
                    :advert-b-data="advertBData"
                    :shop-data="shopData"
                    :brand-data="brandData"
                    :nine-data="nineData"
                    :tlj-data="tljData"
                    :goods-data="goodsData"
                    v-on:loadMore="fetchTopGoodsList"
                    v-on:mainScrollToTop="setMainScrollToTop"
                    v-on:wrapScrollToTop="setWrapScrollToTop"
                    ref="home"
            />
        </div>
        <div v-else>
            <IfanliHome
                    :style-name="app.template.style"
                    :banner-data="bannerData"
                    :headline-data="headlineData"
                    :advert-a-data="advertAData"
                    :advert-b-data="advertBData"
                    :shop-data="shopData"
                    :brand-data="brandData"
                    :nine-data="nineData"
                    :tlj-data="tljData"
                    :goods-data="goodsData"
                    v-on:loadMore="fetchTopGoodsList"
                    v-on:mainScrollToTop="setMainScrollToTop"
                    v-on:wrapScrollToTop="setWrapScrollToTop"
                    ref="home"
            />
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    import IfanliHome from './ifanli/Home';
    import NTfanliHome from './92fanli/Home';
    import DamaiHome from './damai/Home';
    import {appService} from '../services/app';
    import {config} from '../libs/config';
    import {isEmpty, isMobile} from '../libs/utils';

    const _ = require('lodash');

    export default {
        name: 'Home',
        components: {IfanliHome, NTfanliHome, DamaiHome},
        data() {
            return {
                bannerData: {
                    status: false,
                    list: []
                },
                headlineData: {
                    status: false,
                    list: []
                },
                advertAData: {
                    status: false,
                    advert1: {img: '', url: ''},
                    advert2: {img: '', url: ''},
                    advert3: {img: '', url: ''},
                    advert4: {img: '', url: ''},
                    advert5: {img: '', url: ''}
                },
                advertBData: {
                    status: false,
                    advert1: {img: '', url: ''},
                    advert2: {img: '', url: ''},
                    advert3: {img: '', url: ''},
                    advert4: {img: '', url: ''},
                    advert5: {img: '', url: ''}
                },
                shopData: {
                    status: false,
                    list: []
                },
                brandData: {
                    status: false,
                    ad: {img: '', url: ''},
                    list: []
                },
                nineData: {
                    status: false,
                    ad: {img: '', url: ''},
                    list: []
                },
                tljData: {
                    status: false,
                    ad: {img: '', url: ''},
                    list: []
                },
                goodsData: {
                    status: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                },
                mainScrollTop: 0,
                wrapScrollToTop: 0,
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }
            let self = this;
            appService.fetchHomeSlides().then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.bannerData.list = data;
                }
                self.bannerData.status = true;
            });

            appService.fetchHomeHeadlines().then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.headlineData.list = data;
                }
                self.headlineData.status = true;
            });

            appService.fetchHomeAdverts(0).then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    let ads = _.concat(data);
                    if (ads.length === 5) {
                        self.advertAData.advert1.url = ads[4].url;
                        self.advertAData.advert1.img = ads[4].img_path;
                        self.advertAData.advert2.url = ads[3].url;
                        self.advertAData.advert2.img = ads[3].img_path;
                        self.advertAData.advert3.url = ads[2].url;
                        self.advertAData.advert3.img = ads[2].img_path;
                        self.advertAData.advert4.url = ads[1].url;
                        self.advertAData.advert4.img = ads[1].img_path;
                        self.advertAData.advert5.url = ads[0].url;
                        self.advertAData.advert5.img = ads[0].img_path;
                        self.advertAData.status = true;
                    }
                }
            });

            appService.fetchHomeAdverts(29).then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    let ads = _.concat(data);
                    if (ads.length === 5) {
                        self.advertBData.advert1.url = ads[4].url;
                        self.advertBData.advert1.img = ads[4].img_path;
                        self.advertBData.advert2.url = ads[3].url;
                        self.advertBData.advert2.img = ads[3].img_path;
                        self.advertBData.advert3.url = ads[2].url;
                        self.advertBData.advert3.img = ads[2].img_path;
                        self.advertBData.advert4.url = ads[1].url;
                        self.advertBData.advert4.img = ads[1].img_path;
                        self.advertBData.advert5.url = ads[0].url;
                        self.advertBData.advert5.img = ads[0].img_path;
                        self.advertBData.status = true;
                    }
                }
            });

            appService.fetchTopShopList({
                pageNum: 1,
                pageSize: config.HOME_GOODS_SHOP_LIMIT
            }).then((res) => {
                let {code, data: {list}} = res;
                if (code === 200) {
                    self.shopData.list = list;
                    self.shopData.status = true;
                }
            });

            appService.fetchHomeAdverts(30).then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.brandData.ad.img = data[0].img_path;
                    self.brandData.ad.url = data[0].url;
                    self.brandData.status = true;
                }
            });

            appService.fetchHomeAdverts(31).then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.nineData.ad.img = data[0].img_path;
                    self.nineData.ad.url = data[0].url;
                    self.nineData.status = true;
                }
            });

            appService.fetchHomeAdverts(32).then((res) => {
                let {code, data} = res;
                if (code === 200 && !isEmpty(data)) {
                    self.tljData.ad.img = data[0].img_path;
                    self.tljData.ad.url = data[0].url;
                    self.tljData.status = true;
                }
            });

            appService.fetchTopTljs().then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.tljData.list = data;
                }
            });

            appService.fetchHomeGoodsBlock().then((res) => {
                let {code, data} = res;
                if (code === 200) {
                    self.brandData.list = data['hot'];
                    self.nineData.list = data['nine'];
                }
            });

            appService.fetchUserInfo();

            self.fetchTopGoodsList();
        },
        watch: {
            '$route'(param) {
                if (param.name === 'home') {
                    this.setBottomBarIndex(0);
                    this.$refs.home.setScrollPosition(this.app.homeMainScrollY, this.app.homeWrapScrollY);
                    this.$store.commit('changeHomeMainScrollY', 0);
                    this.$store.commit('changeHomeWrapScrollY', 0);
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === 'home') {
                this.$store.commit('changeHomeMainScrollY', 0);
                this.$store.commit('changeHomeWrapScrollY', 0);
            } else {
                this.$store.commit('changeHomeMainScrollY', this.mainScrollTop);
                this.$store.commit('changeHomeWrapScrollY', this.wrapScrollToTop);
            }
            next()
        },
        mounted() {
            this.setBottomBarIndex(0);
        },
        methods: {
            ...mapMutations([
                'setBottomBarIndex'
            ]),
            fetchTopGoodsList: function () {
                let self = this;

                if (self.goodsData.isMore === true && self.goodsData.loading === false) {
                    self.goodsData.loading = true;
                    appService.fetchTopGoodsList({pageNum: self.goodsData.pageNum}).then((res) => {
                        let {code, data} = res;
                        if (code === 200) {
                            if (data['list'].length > 0) {
                                for (let i = 0; i < data['list'].length; i++) {
                                    self.goodsData.list.push(data['list'][i]);
                                }
                                self.goodsData.isMore = true;
                                self.goodsData.pageNum++;
                            } else {
                                self.goodsData.isMore = false;
                            }
                        }
                        self.goodsData.loading = false;
                    });
                }
            },
            setMainScrollToTop: function (top) {
                this.mainScrollTop = top;
            },
            setWrapScrollToTop: function (top) {
                this.wrapScrollToTop = top;
            }
        }
    }
</script>
